import { ProductMaterial } from 'app/ts/clientDto/ProductMaterial';
export class RailMaterial {
  constructor(
    public readonly topMaterial: ProductMaterial,
    public readonly bottomMaterial: ProductMaterial,
  ) {}
}
